import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const LOGO = "https://customer-assets.emergentagent.com/job_transform-beauty-4/artifacts/z9s3xb3p_APHEA%20BRANDMARK%20WHITE.png";

const thumbUrl = (id) => `https://lh3.googleusercontent.com/d/${id}=w600`;
const fullUrl  = (id) => `https://lh3.googleusercontent.com/d/${id}=w1600`;

export default function Gallery() {
  const [photos, setPhotos]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [lb, setLb]           = useState(null); // lightbox index

  useEffect(() => {
    axios.get(`${API}/gallery`)
      .then(r => { setPhotos(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const prev = useCallback(() => setLb(i => (i - 1 + photos.length) % photos.length), [photos.length]);
  const next = useCallback(() => setLb(i => (i + 1) % photos.length), [photos.length]);

  useEffect(() => {
    const handler = (e) => {
      if (lb === null) return;
      if (e.key === "ArrowLeft")  prev();
      if (e.key === "ArrowRight") next();
      if (e.key === "Escape")     setLb(null);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [lb, prev, next]);

  return (
    <div className="gallery-page" data-testid="gallery-page">
      {/* NAVBAR */}
      <nav className="gallery-nav">
        <Link to="/" className="gallery-nav-logo" data-testid="gallery-logo-link">
          <img src={LOGO} alt="APHEA" />
        </Link>
        <h2 className="gallery-nav-title">Galeri</h2>
        <Link to="/" className="gallery-nav-back" data-testid="gallery-back-link">← Ana Sayfaya Dön</Link>
      </nav>

      {/* GRID */}
      {loading ? (
        <div className="gallery-loading" data-testid="gallery-loading">
          <div className="gallery-spinner" />
        </div>
      ) : (
        <div className="gallery-masonry" data-testid="gallery-grid">
          {photos.map((photo, i) => (
            <div
              key={photo.filename}
              className="gallery-item"
              onClick={() => setLb(i)}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={thumbUrl(photo.drive_id)}
                alt={photo.filename}
                loading="lazy"
                className="gallery-img"
              />
              <div className="gallery-overlay">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  <line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
                </svg>
              </div>
            </div>
          ))}
        </div>
      )}

      {photos.length === 0 && !loading && (
        <div className="gallery-empty">Henüz fotoğraf eklenmemiş.</div>
      )}

      {/* FOOTER */}
      <footer className="gallery-footer">
        <p>© 2026 APHEA Güzellik & Dönüşüm Merkezi &nbsp;·&nbsp; www.aphea.life</p>
      </footer>

      {/* LIGHTBOX */}
      {lb !== null && (
        <div className="gallery-lightbox" data-testid="gallery-lightbox" onClick={() => setLb(null)}>
          <button className="lb-close" onClick={() => setLb(null)} data-testid="lb-close">✕</button>
          <button className="lb-prev" onClick={(e) => { e.stopPropagation(); prev(); }} data-testid="lb-prev">‹</button>
          <div className="lb-img-wrap" onClick={e => e.stopPropagation()}>
            <img src={fullUrl(photos[lb].drive_id)} alt={photos[lb].filename} className="lb-img" />
          </div>
          <button className="lb-next" onClick={(e) => { e.stopPropagation(); next(); }} data-testid="lb-next">›</button>
          <div className="lb-counter" data-testid="lb-counter">{lb + 1} / {photos.length}</div>
        </div>
      )}
    </div>
  );
}
